import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@dhl/theme'

export const FlagSE: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 9 6">
    <rect width="9" height="6" fill="#006aa7" />
    <rect width="2" height="6" x="3" fill="#fecc00" />
    <rect width="9" height="2" y="2" fill="#fecc00" />{' '}
  </SvgIcon>
)
